import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import Loading from './common/components/Loading/Loading';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Suspense fallback={<Loading />}>
    <App />
  </Suspense>
);
